<script context="module">
  export const authErrorModal = new ModalQueryState('auth-error');
</script>

<script lang="ts">
  import Close from '~icons/mdi/close';
  import ActionButton from '~/components/ActionButton.svelte';
  import Modal from '~/components/Modal.svelte';
  import { ModalQueryState } from '~/lib/nav.svelte';

  const onClose = () => {
    authErrorModal.pop();
  };
</script>

<Modal index={7} open={authErrorModal.open} {onClose}>
  {#snippet title()}
    Authentication Error
  {/snippet}
  {#snippet content()}
    {authErrorModal.value}
    <p>
      Reach out to <a href="mailto:support@gramjam.app">support@gramjam.app</a> for
      further assistance.
    </p>
  {/snippet}
  {#snippet controls()}
    <ActionButton onClick={onClose}><Close />CLOSE</ActionButton>
  {/snippet}
</Modal>
